import { CellContext } from '@tanstack/react-table';
import { CellLink } from '@/components/table/_fieldDefinitions/_base/CellLink.tsx';
import { CANCELLED_RECORD_CLASS } from '@/components/table/_fieldDefinitions/_base/cancelledRecord.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { cn } from '@/lib/utils.ts';
import { SimpleNestedParticipant } from '@/features/dashboard/participants/types/SimpleNestedParticipant.ts';
import { ParticipantStatus } from '@/features/dashboard/participants/types/ParticipantStatus.ts';

export const nestedParticipantFieldRender = <T,>(
  info: CellContext<T, unknown>,
) => {
  const value = info.getValue() as SimpleNestedParticipant | null | undefined;
  // jOOQ oddaje brak osoby jako obiekt z samymi `null`-ami, nie jako `null`.
  if (!value?.id) return <EmptyValue />;
  const withdrawn = value.status === ParticipantStatus.WITHDRAWN;
  return (
    <CellLink
      to="/app/participants/$participantId/info"
      params={{ participantId: value.id }}
      importance={info.column.columnDef.meta?.importance}
      className={cn(withdrawn && CANCELLED_RECORD_CLASS)}
    >
      {value.firstName} {value.lastName}
    </CellLink>
  );
};
